// components/ConfirmDialog.jsx
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

export const ConfirmDialog = ({ dialogProps }) => {
  const { isOpen, onClose, cancelRef, options } = dialogProps;

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {options.title}
          </AlertDialogHeader>

          <AlertDialogBody>{options.message}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={options.onCancel}>
              {options.cancelText}
            </Button>
            <Button colorScheme="red" onClick={options.onConfirm} ml={3}>
              {options.confirmText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
